import { APIWorkspaceAttributes, ArdoqId, NamedEntity } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { TrackingLocation } from '@ardoq/data-model';

export const workspaceNamespace = 'workspace';

interface WorkspacePayload {
  workspaceId: ArdoqId;
}

export const notifyWorkspaceAggregatedLoaded = actionCreator<WorkspacePayload>(
  '[workspaces] NOTIFY_WORKSPACE_AGGREGATED_LOADED'
);

export const markWorkspaceAggregatedLoaded = actionCreator<WorkspacePayload>(
  '[workspaces] MARK_WORKSPACE_AGGREGATED_LOADED'
);

export const markWorkspaceAggregatedUnloaded = actionCreator<WorkspacePayload>(
  '[workspaces] MARK_WORKSPACE_AGGREGATED_UNLOADED'
);

export const notifyWorkspacesDeleted = actionCreator<{
  workspaceIds: ArdoqId[];
}>('[workspaces] NOTIFY_WORKSPACES_DELETED');

type OpenWorkspacePayload = {
  workspaceId: ArdoqId;
  keepCurrentContext: boolean;
  trackingLocation?: TrackingLocation;
};
export const openWorkspace = actionCreator<OpenWorkspacePayload>(
  '[workspaces] OPEN_WORKSPACE'
);

type ComponentInWorkspaceNavigationRequestedPayload = {
  componentId: ArdoqId;
  trackingLocation?: TrackingLocation;
};
export const componentInWorkspaceNavigationRequested =
  actionCreator<ComponentInWorkspaceNavigationRequestedPayload>(
    '[workspaces] COMPONENT_IN_WORKSPACE_NAVIGATION_REQUESTED'
  );

type WorkspaceNavigationRequestedPayload = {
  workspaceId: ArdoqId;
  trackingLocation?: TrackingLocation;
};
export const workspaceNavigationRequested =
  actionCreator<WorkspaceNavigationRequestedPayload>(
    '[workspaces] WORKSPACE_NAVIGATION_REQUESTED'
  );

/**
 * This action is dispatched when user clicks the delete button in the workspace options menu.
 * This will open a modal that asks the user to confirm the deletion and make a http call
 * for deleting the workspace.
 */
export const confirmDeleteWorkspace = actionCreator<NamedEntity>(
  '[workspace] WORKSPACE_OPTIONS_CONFIRM_DELETE_WORKSPACE'
);

export const closeAllWorkspaces = actionCreator(
  '[workspace] CLOSE_ALL_WORKSPACES'
);

export const requestCloseAllDatasets = actionCreator(
  '[workspace] REQUEST_CLOSE_ALL_DATASETS'
);

type CopyWorkspacePayload = {
  sourceWorkspaceId: ArdoqId;
  newName: string;
  copyComponents: boolean;
  copyReferences: boolean;
  copyCrossWorkspaceReferences: boolean;
};

export const copyWorkspace = actionCreator<CopyWorkspacePayload>(
  '[workspace] COPY_WORKSPACE'
);

export const copyWorkspaceSucceeded = actionCreator(
  '[workspace] COPY_WORKSPACE_SUCCEEDED'
);

export type AddWorkspacesPayload = {
  workspaces: APIWorkspaceAttributes[];
  silent?: boolean;
};

export const addWorkspaces = actionCreator<AddWorkspacesPayload>(
  '[workspace] ADD_WORKSPACES'
);

export const resetWorkspaces = actionCreator<void>(
  '[workspace] RESET_WORKSPACES'
);

export const resetWorkspacesWithData = actionCreator<AddWorkspacesPayload>(
  '[workspace] RESET_WORKSPACES_WITH_PAYLOAD'
);

export const removeWorkspaces = actionCreator<ArdoqId[]>(
  '[workspace] REMOVE_WORKSPACES'
);
